<template>
  <row :gutter="16">
    <i-col span="8">
      <div class="ms-text">
        Стоимость подписанных актов
      </div>
      <alert>
        {{ getFormattedCosts(stats.signed_act_costs, false, withVat) }}
      </alert>
    </i-col>
    <i-col span="8">
      <div class="ms-text">
        Стоимость неподписанных актов
      </div>
      <alert type="warning">
        {{ getFormattedCosts(stats.not_signed_act_costs, false, withVat) }}
      </alert>
    </i-col>
    <i-col span="8">
      <div class="ms-text">
        Отклонение по актам
      </div>
      <alert type="error">
        {{ getLagValue() }}
      </alert>
    </i-col>
  </row>
</template>

<script>
import { getFormattedCosts } from '@/utils'

export default {
  props: ['stats', 'contract-page'],
  computed: {
    withVat () {
      return this.$store.state.contracts.current.with_vat
    }
  },
  methods: {
    getLagValue () {
      const value = this.contractPage ? this.stats.act_payment_lag : this.stats.act_value_lag

      return getFormattedCosts(value > 0 ? value : 0, false, this.withVat)
    },
    getFormattedCosts
  }
}
</script>

<style>
</style>
